/* 🤖 this file was generated by svg-to-ts */
export const myIconBriefcase: {
  name: 'briefcase';
  data: string;
} = {
  name: 'briefcase',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 15"><path fill="currentColor" d="M2 14.75c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06V5c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h3V2c0-.413.147-.766.44-1.06C5.735.648 6.088.5 6.5.5h3c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v1.5h3c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06v8.25c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H2Zm0-1.5h12V5H2v8.25ZM6.5 3.5h3V2h-3v1.5Z"/></svg>`,
};
